import { useState } from "react";
import { format, parse, isValid } from "date-fns";
import { enAU } from "date-fns/locale";
import { CalendarDays } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Calendar } from "@/components/ui/calendar";
import { Input } from "@/components/ui/input";

const toDate = (s) => {
  if (!s) return undefined;
  const d = parse(s.slice(0, 10), "yyyy-MM-dd", new Date());
  return isValid(d) ? d : undefined;
};

export const DatePicker = ({ value, onChange, testId, placeholder = "dd/mm/yyyy", className = "" }) => {
  const [open, setOpen] = useState(false);
  const d = toDate(value);
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button type="button" data-testid={testId}
          className={`flex h-9 w-full items-center justify-between rounded-md border border-input bg-white px-3 text-left text-sm shadow-sm transition-colors hover:border-stone-400 ${d ? "text-stone-900" : "text-stone-400"} ${className}`}>
          {d ? format(d, "dd/MM/yyyy") : placeholder}
          <CalendarDays className="h-4 w-4 text-stone-400" />
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0" align="start">
        <Calendar mode="single" locale={enAU} weekStartsOn={1} selected={d} defaultMonth={d}
          onSelect={(v) => { onChange(v ? format(v, "yyyy-MM-dd") : ""); setOpen(false); }} initialFocus />
        {d && <button type="button" onClick={() => { onChange(""); setOpen(false); }} className="w-full border-t py-2 text-xs text-stone-500 hover:text-stone-900">Clear date</button>}
      </PopoverContent>
    </Popover>
  );
};

export const DateTimePicker = ({ value, onChange, testId }) => {
  const date = value ? value.slice(0, 10) : "";
  const time = value && value.length > 10 ? value.slice(11, 16) : "09:00";
  return (
    <div className="flex gap-2">
      <DatePicker testId={testId} value={date} onChange={(d) => onChange(d ? `${d}T${time}` : "")} />
      <Input data-testid={`${testId}-time`} type="time" step={900} value={time} disabled={!date} onChange={(e) => onChange(`${date}T${e.target.value}`)} className="w-32 bg-white" />
    </div>
  );
};
